import React, { useState } from "react"
import { Container, Row, Col, Modal, ModalBody, Button } from "reactstrap"
import { Link } from "gatsby"

import FormRequest from "../form"
import Animate from "../animate"

import background from "../../images/lead-bg.jpg"
import logo from "../../images/logo.svg"

const LeadSection = ({ title }) => {
  const [modal, setModal] = useState(false)

  const toggle = () => setModal(!modal)

  return (
    <section className="section section--white section_lead" id="lead">
      <div
        className="section_bg"
        style={{ backgroundImage: `url(${background})` }}
      />
      <Container>
        <Row className="align-items-md-center align-items-lg-end">
          <Col md={7} lg={8}>
            <Animate className="slide-up delay-2">
              <h1 className="h2">{title}</h1>
            </Animate>
          </Col>
          <Col md={5} lg={4}>
            <div className="d-none d-md-block">
              <Animate className="slide-up delay-3">
                <FormRequest />
              </Animate>
            </div>
            <div className="d-md-none">
              <Animate className="slide-up delay-3">
                <div className="card">
                  <div className="form_title">
                    Рассчитать бесплатно стоимость банкротства
                  </div>
                  <br />
                  <Button color="primary" block type="button" onClick={toggle}>
                    Отправить запрос
                  </Button>
                </div>
              </Animate>

              <Modal isOpen={modal} toggle={toggle}>
                <button
                  type="button"
                  className="active navbar-toggler"
                  onClick={toggle}
                >
                  <span className="navbar-toggler-icon"></span>
                </button>

                <ModalBody>
                  <div className="header_logo">
                    <Link to="/">
                      <img src={logo} alt="logo" width="200px" />
                    </Link>
                    <div className="header_logo__text">
                      сервис создан при поддержке Аронов&nbsp;и&nbsp;Партнеры
                    </div>
                  </div>
                  <FormRequest handlerClick={toggle} />
                </ModalBody>
              </Modal>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default LeadSection
